import Vue from 'vue';

export const RUBLE_SIGN = '\u20BD';
export const NO_BREAK = '\u00A0';

Vue.filter('sum', (value, hasPrefix = false) => {
  const prefix = hasPrefix ? NO_BREAK : '';
  return prefix + value + NO_BREAK + RUBLE_SIGN;
});
